RivalIQ.apps.Shell.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    data.notifications = new Backbone.Collection([
        {
            id: App.enums.notifications.TRIAL,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.SHORT] = '#shellTrialBannerTemplate';
            })
        },
        //  id: App.enums.notifications.TRIAL_KEY_GEO is deprecated per #16293
        {
            id: App.enums.notifications.TRIAL_EXPIRES_SOON,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.SHORT] = '#shellTrialExpiresSoonShortTemplate';
            })
        },
        //  id: App.enums.notifications.TRIAL_EXPIRES_SOON_NON_TRIAL_PLAN is deprecated per #16293
        {
            id: App.enums.notifications.TRIAL_EXPIRED,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.TALL] = '#shellTrialExpiredTallTemplate';
                templates[App.enums.navigation_size.DEFAULT] = '#shellTrialExpiredShortTemplate';
            })
        },
        {
            id: App.enums.notifications.CANCELED,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.DEFAULT] = '#shellAccountCanceledTemplate';
            })
        },
        {
            id: App.enums.notifications.RENEWAL_CENTER,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.SHORT] = '#shellRenewalCenterTemplate';
            })
        },
        {
            id: App.enums.notifications.PAYMENT_OVERDUE,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.SHORT] = '#shellPaymentOverdueTemplate';
            })
        },
        {
            id: App.enums.notifications.EXPIRED_TOKENS,
            templates: _.tap({}, function (templates) {
                templates[App.enums.navigation_size.TALL] = '#shellExpiredTokensTemplate';
            })
        }
    ]);

});
